const BUNDLE_TYPE = Object.freeze({
  pega: 'pega',
  custom: 'custom',
  standard: 'standard'
})

const getCustomTariffPlan = (plans, id) => {
  const planData = (plans ?? []).find(plan => plan.id === id)
  if (planData) {
    return {
      plan: {
        id: planData.id,
        name: 'tariffPlan',
        value: planData.name
      },
      terms: planData.productTerms
    }
  }
}

const getCustomSpeed = (speeds, id) => {
  const speedData = (speeds ?? []).find(speed => speed.id === id)
  if (speedData) {
    return {
      internet: {
        name: 'Internet',
        id: speedData.id,
        value: speedData.packageName
      },
      download: {
        id: 'string',
        name: 'downloadSpeed',
        value: speedData.value
      }
    }
  }
}

const getCustomSlot = (slots, id) => {
  const slotData = (slots ?? []).find(slot => slot.id === id)
  if (slotData) {
    return {
      id: slotData.id,
      name: 'members',
      value: slotData.id
    }
  }
}

const getSelectedBundleData = ({
  customTVs,
  bundleType,
  atlBundles,
  pegaBundles,
  customPlans,
  customSlots,
  customSpeeds,
  selectedBundle,
  customBundlePrice,
  customBundleOptions
}) => {
  if (bundleType === BUNDLE_TYPE.custom) {
    const tariffPlan = getCustomTariffPlan(
      customPlans.data,
      customBundleOptions.plan
    )
    const speed = getCustomSpeed(customSpeeds.data, customBundleOptions.speed)
    return {
      // General
      recommended: false,
      id: 'custom_bundle',
      name: 'unlimited_family_offer',
      // Price & Discount
      price: customBundlePrice.price,
      discount: customBundlePrice.discount,
      // Bundle Configuration
      tv: (customTVs.data ?? []).find(tv => tv.id === customBundleOptions.tv),
      slots: getCustomSlot(customSlots.data, customBundleOptions.slots),
      internet: speed?.internet,
      tariffPlan: tariffPlan?.plan,
      download: speed?.download,
      // Terms
      productTerms: tariffPlan?.terms
    }
  } else {
    return bundleType === BUNDLE_TYPE.pega
      ? pegaBundles.data.find(bundle => bundle.id === selectedBundle)
      : atlBundles.data.find(bundle => bundle.id === selectedBundle)
  }
}

export { getSelectedBundleData, BUNDLE_TYPE }
